import React, { useEffect } from 'react';
import { X } from 'lucide-react';


const CustomAlert = ({ message, isVisible, onClose }) => {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);

  if (!isVisible) return null;

  return (
    <div className="fixed top-4 right-4 z-50 animate-fade-in">
      <div className="bg-emerald-100 border border-emerald-200 text-emerald-700 px-4 py-3 rounded-lg shadow-lg flex items-center">
        <span>{message}</span>
        <button
          onClick={onClose}
          className="ml-3 hover:text-emerald-900"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default CustomAlert;